import { useContext, useState, useRef } from "react";
import { DefaultContext } from "../../../../contexts/default";
import PageWrapper from "../../../../layout/PageWrapper/PageWrapper";
import { demoPages } from "../../../../menu";
import SubHeader, { SubHeaderLeft, SubHeaderRight } from "../../../../layout/SubHeader/SubHeader";
import Breadcrumb from "../../../../components/bootstrap/Breadcrumb";
import React from "react";
import Page from "../../../../layout/Page/Page";
import Card, { CardBody } from "../../../../components/bootstrap/Card";
import SelectEstablishment from "../../../../components/MyCustom/SelectEstablishment";
import SelectStore from "../../../../components/MyCustom/SelectStore";
import Icon from "../../../../components/icon/Icon";
import Button from "../../../../components/bootstrap/Button";
import ModalEditIntegrations from "../../../../components/modals/Integrations/ModalEditIntegrations";
import { ResultsContext } from "../../../../contexts/results";

const integrationConfig = {
    '99': {
        label: "99Food",
        fields: ["store_99", "token_99"],
    },
    everest: {
        label: "Everest",
        fields: ["everest"]
    },
    ifood: {
        label: "iFood",
        fields: ["ifood_id", "ifood_catalog"],
    },
    omie: {
        label: "Omie",
        fields: ["omie_app_key", "omie_secret"],
    },
    rappi: {
        label: "Rappi",
        fields: ["rappi_id"],
    },
};

const getIntegrationStatus = (integration, type) => {
    if (!integration) {
        return { color: "#6c757d", icon: "Help", text: "Carregando..." };
    }

    const fields = integrationConfig[type].fields;
    const filled = fields.filter((f) => !!integration[f]);

    if (filled.length === fields.length) {
        return { color: "#28a745", icon: "CheckCircle", text: "Ativo" };
    }
    if (filled.length > 0) {
        return { color: "#ffc107", icon: "Warning", text: "Parcial" };
    }
    return { color: "#dc3545", icon: "Cancel", text: "Inativo" };
};

const renderIntegrationVariables = (integration, type) => {
    const { label, fields } = integrationConfig[type];

    if (!integration) {
        return (
            <div className="p-2">
                <small className="text-muted">Carregando dados...</small>
            </div>
        );
    }

    return (
        <div className="p-3">
            <h6 className="mb-2 text-white">Variáveis {label}:</h6>

            {fields.map((field) => (
                <div key={field} className="mb-1">
                    <strong>{field}:</strong>{" "}
                    {integration[field]
                        ? field.includes("token") || field.includes("secret")
                            ? "***configurado***"
                            : integration[field]
                        : "null"}
                </div>
            ))}
        </div>
    );
};

const IntegrationCard = ({ type, integration, onHover, onLeave }) => {
    const status = getIntegrationStatus(integration, type);
    const { label } = integrationConfig[type];

    return (
        <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <Card
                className="h-100 text-center card-hover"
                onMouseEnter={(e) => onHover(type, e)}
                onMouseLeave={onLeave}
            >
                <CardBody className="d-flex flex-column align-items-center justify-content-center p-4">
                    <Icon
                        icon={status.icon}
                        size="3x"
                        style={{ color: status.color }}
                        className="mb-3"
                    />
                    <h6 className="mb-0">{label}</h6>
                </CardBody>
            </Card>
        </div>
    );
};

const Integrations = () => {
    const { user } = useContext(DefaultContext);
    const { integrationsData } = useContext(ResultsContext)

    //const [integration, setIntegration] = useState(null);
    const [hovered, setHovered] = useState(null);
    const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
    const [modalOpen, setModalOpen] = useState(false);

    const tooltipTimeout = useRef(null);

    const handleToggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleMouseEnter = (type, event) => {
        clearTimeout(tooltipTimeout.current);
        setHovered(type);

        const rect = event.currentTarget.getBoundingClientRect();
        setTooltipPos({
            x: rect.left + rect.width / 2,
            y: rect.bottom + 10,
        });
    };

    const handleMouseLeave = () => {
        tooltipTimeout.current = setTimeout(() => setHovered(null), 50);
    };

    return (
        <>
            <PageWrapper title={demoPages.pageLayout.subMenu.integrations.text}>
                <SubHeader className="py-3">
                    <SubHeaderLeft>
                        <Breadcrumb
                            list={[
                                { title: "Loja", to: "/store" },
                                { title: "Integrações", to: "/store/integrations" },
                            ]}
                        />
                    </SubHeaderLeft>

                    <SubHeaderRight>
                        {user.role === "admin" && (
                            <div className="row d-flex justify-content-end">
                                <SelectEstablishment />
                                <SelectStore />
                            </div>
                        )}

                        <Button
                            color="primary"
                            size="lg"
                            icon="Settings"
                            onClick={handleToggleModal}
                        >
                            Configurar Integrações
                        </Button>
                    </SubHeaderRight>
                </SubHeader>

                <Page container="fluid">
                    {/* Cards */}
                    <div className="row mb-4">
                        {Object.keys(integrationConfig).map((type) => (
                            <IntegrationCard
                                key={type}
                                type={type}
                                integration={integrationsData}
                                onHover={handleMouseEnter}
                                onLeave={handleMouseLeave}
                            />
                        ))}
                    </div>

                    {hovered && (
                        <div
                            style={{
                                position: "fixed",
                                left: Math.max(
                                    10,
                                    Math.min(tooltipPos.x - 100, window.innerWidth - 210)
                                ),
                                top: tooltipPos.y,
                                backgroundColor: "rgba(0, 0, 0, 0.9)",
                                color: "white",
                                borderRadius: "8px",
                                fontSize: "12px",
                                zIndex: 1050,
                                minWidth: "200px",
                                maxWidth: "300px",
                                pointerEvents: "none",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                opacity: 1,
                                transition: "opacity 0.2s ease-in-out",
                            }}
                        >
                            {renderIntegrationVariables(integrationsData, hovered)}
                        </div>
                    )}
                </Page>
            </PageWrapper>

            <ModalEditIntegrations
                open={modalOpen}
                handleOpen={handleToggleModal}
                integration={integrationsData || {}}
            />
        </>
    );
};

export default Integrations;
